<template>
  <div class="content" style="border-radius:4px;overflow:hidden;">
    <div style="height:250px;text-align:center;background-color:black;">
      <fx-avatar defalutImg="static/img/userface.jpg" style="height:100%" v-show="!isModifyFace" />
      <VueCropper v-show="isModifyFace" ref="cropper" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType" :info="option.info" :autoCrop="option.autoCrop" :fixedBox="option.fixedBox" :centerBox="option.centerBox" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight"></VueCropper>
    </div>
    <div v-show="!isModifyFace">
      <Button type="primary" ref="pickfiles" style="border-radius:unset;" long>修改头像</Button>
    </div>
    <div v-show="isModifyFace" style="display:flex;">
      <Button type="primary" style="border-radius:unset;flex:1;border-right:1px solid #efefef;" @click="closeCrop" long>取消</Button>
      <Button type="primary" style="border-radius:unset;flex:1;" @click="startCrop" long>确定修改</Button>
    </div>
  </div>
</template>

<script>
import plupload from "plupload";
import { VueCropper } from "vue-cropper";

const filetoBase64 = file => {
  return new Promise((resolve, reject) => {
    let _this = this;
    let reader = new FileReader();
    // reader.onloadstart = () => console.log("开始读取...");
    // reader.onprogress = () => console.log("正在读取...");
    // reader.onabort = () => console.log("中断读取...");
    // reader.onerror = () => console.log("读取异常...");
    reader.readAsDataURL(file);
    reader.onload = result => {
      // console.log("成功读取...");
      resolve(result.target.result);
    };
  });
};
const dataURLtoFile = (dataurl, filename) => {
  //将base64转换为文件
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
};

export default {
  data() {
    return {
      imgName: "face.jpeg",
      isModifyFace: false,
      option: {
        img: "",
        outputSize: 1,
        outputType: "jpeg",
        info: false,
        autoCrop: true,
        fixedBox: true,
        centerBox: true,
        autoCropWidth: 200,
        autoCropHeight: 200
      }
    };
  },
  computed: {
    faceSrc: {
      get() {
        let _this = this;
        if (_this.option.img !== "") {
          return _this.option.img;
        }
        return _this.$store.state.core.getFacebyUserID(_this.$store.state.core.user.userid);
      },
      set(val) {
        let _this = this;
        _this.option.img = val;
        _this.$curl
          .upload(`/api/core/personal/uploadface`, {
            file: dataURLtoFile(val, _this.imgName)
          })
          .then(() => {
            _this.$store.commit("core/setUserface");
          });
      }
    }
  },
  components: {
    VueCropper
  },
  methods: {
    startCrop() {
      let _this = this;
      _this.$refs.cropper.getCropData(data => {
        _this.isModifyFace = false;
        _this.faceSrc = data;
      });
    },
    closeCrop() {
      let _this = this;
      _this.isModifyFace = false;
      _this.option.img = "";
    }
  },
  mounted() {
    let _this = this;

    this.$nextTick(() => {
      // let crsf = _this.$cookies.get("csrfToken");
      // let uploadurl = `/api/core/personal/uploadface?_csrf=${crsf}`;
      let uploadurl = "/api/core/personal/uploadface";
      let uploader = new plupload.Uploader({
        runtimes: "html5,silverlight,flash,html4",
        browse_button: _this.$refs.pickfiles.$el, // you can pass in id...
        //container: document.getElementById('container'), // ... or DOM Element itself
        url: uploadurl,
        multi_selection: false, //禁止多选
        flash_swf_url: "../js/Moxie.swf",
        silverlight_xap_url: "../js/Moxie.xap",
        filters: {
          //max_file_size : '10mb',
          mime_types: []
        },
        init: {
          FilesAdded: function(up, files) {
            filetoBase64(files[0].getNative()).then(res => {
              _this.isModifyFace = true;
              _this.option.img = res;
            });
          }
        }
      });
      uploader.init();
    });
  }
};
</script>

<style lang="scss" scoped>
</style>